export const SALES_PHONE_TEL = "tel:+6281387606852";
export const SALES_PHONE_NUMBER = "+62 813 8760 6852";

export const OTP_CREATED_TIME_TYPE = {
  verification: 1,
  transaction: 2,
  pwf: 3,
  international_transfer: 4,
  deposit: 5
};

export const DEFAULT_OPS_TIME = {
  operation_start_day: "Senin",
  operation_end_day: "Minggu",
  operation_start_hour: "07.00",
  operation_end_hour: "20.00"
};

export const TEST_MODE = {
  SANDBOX: "sandbox",
  LIVE: "live"
};

export const BIG_FLIP_SERVICE_TYPE = {
  BIG_FLIP: 4,
  BIG_FLIP_INSTANT: 11, // default
  BIG_FLIP_INSTANT_CHEAP: 13,
  BIG_FLIP_INSTANT_CHEAP_MAX: 14,
  BIG_FLIP_INSTANT_CHEAP_MAX_NO_BACKUP: 15,
  BIG_FLIP_TRIAL: 16
};
